<template>
  <div id="app">
    <Bloco1Navbar />
    <!--<Bloco1NavbarV1 />-->

    <router-view/>

    <!--<div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>-->
  </div>
</template>

<script>
import Bloco1Navbar from "./components/homeBlocos/Bloco1Navbar";


//import Bloco1NavbarV1 from "./components/homeBlocos/Bloco1Navbar-v1"; Bloco1NavbarV1,
export default {
  components: { Bloco1Navbar}
}
</script>

<style>
/*#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}*/
</style>